import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserAgentService {

  private userAgent: string | null = null;

  constructor() {
    this.init();
  }

  private init() {
    this.userAgent = navigator.userAgent || null;
    console.log('Browser userAgent:', this.userAgent);
  }

  // Returns the user agent if available, or rejects with an error message.
  getBrowserUserAgent(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.userAgent) {
        resolve(this.userAgent);
      } else {
        reject('User agent is not available.');
      }
    });
  }
}
